import { createAction, props } from '@ngrx/store';

import type { MemberAreaUser } from '@common/types/user.type';
import { type EduUser, type LandingPageUser } from '@common/types/user.type';

export const loadUserSuccess = createAction(`[User/Api] Load User Success`, props<{ user: LandingPageUser }>());

export const loadEduUserSuccess = createAction(`[User/Api] Load EDU User Success`, props<{ eduUser: EduUser }>());

export const loadUserFailure = createAction(`[User/Api] Load User Failure`, props<{ error: string }>());

export const loadEduUserFailure = createAction(`[User/Api] Load EDU User Failure`, props<{ eduUserError: string }>());

export const setUserCdnInfo = createAction(
    `[FM/Api] Set User CDN Info`,
    props<{ cdnInfo: { userHash: string; cdn: string; streamCdn: string } }>()
);

export const loadMemberAreaUserSuccess = createAction(
    `[User/Api] Load Member Area User Success`,
    props<{ memberAreaUser: MemberAreaUser }>()
);

export const loadMemberAreaUserFailure = createAction(
    `[User/Api] Load Member Area User Failure`,
    props<{ memberAreaUserError: string }>()
);
